/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type FetchOrdersQueryVariables = Types.Exact<{
	filter: Types.FetchOrdersFilter;
	order: Types.OrderField;
	pagination: Types.PaginationInput;
}>;

export type FetchOrdersQuery = {
	__typename?: "Query";
	fetchOrders: {
		__typename?: "FetchOrdersResponse";
		orders: Array<{
			__typename?: "Order";
			orderId: string;
			status: Types.OrderStatus;
			type: Types.OrderType;
			fiatId: string;
			assetId?: string | null;
			price: { __typename?: "CurrencyAmount"; value: string };
			amount: { __typename?: "CurrencyAmount"; value: string };
			createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
			failedAt?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
		} | null>;
		pageInfo?: {
			__typename?: "PaginationResponse";
			currentPage: number;
			totalPages: number;
			totalItems: number;
		} | null;
	};
};

export const FetchOrdersDocument = gql`
	query fetchOrders($filter: FetchOrdersFilter!, $order: OrderField!, $pagination: PaginationInput!) {
		fetchOrders(filter: $filter, order: $order, pagination: $pagination) {
			orders {
				orderId
				status
				type
				fiatId
				assetId
				price {
					value
				}
				amount {
					value
				}
				createdAt {
					iso8601
					unixTimestamp
				}
				failedAt {
					iso8601
					unixTimestamp
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalItems
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class FetchOrdersGQLService extends Apollo.Query<FetchOrdersQuery, FetchOrdersQueryVariables> {
	document = FetchOrdersDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
